"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundamentalIndication = void 0;
const fundamental_utils_1 = require("../utils/fundamental.utils");
const lucy_1 = require("../../@types/analysis/historical-prices/lucy");
class FundamentalIndication {
    getIndication(data) {
        const cashflow = data.CashFlow;
        const patrimony = data.PatrimonyBalance;
        const demonstrations = data.ResultsDemonstration;
        let indicators = [];
        if (cashflow) {
            indicators = [...this.getCashflowIndicators(cashflow)];
        }
        if (patrimony) {
            indicators = [...indicators, ...this.gePatrimonyIndicators(patrimony)];
        }
        if (demonstrations) {
            indicators = [...indicators, ...this.getDemoIndicators(demonstrations)];
        }
        return {
            results: indicators,
            summary: this.getSummary(indicators),
            internalPoints: this.getInternalPoints(indicators),
        };
    }
    gePatrimonyIndicators(data) {
        const liquid = data.TotalLiquid;
        const output = [];
        if (liquid) {
            output.push({
                name: 'Balanço Patrimonial',
                value: fundamental_utils_1.FundamentalUtils.getLucyIndication(liquid),
            });
        }
        output.push({
            name: 'Gerenciamento de Contas',
            value: fundamental_utils_1.FundamentalUtils.getLucyIndication(liquid),
        });
        return output;
    }
    getCashflowIndicators(data) {
        const operationalActivity = data.OperationalActivity;
        const investmentsActivity = data.InvestimentsActivity;
        const liquidFlow = data.LiquidVariations;
        const output = [];
        if (operationalActivity) {
            output.push({
                name: 'Fluxo de caixa Operacional',
                value: fundamental_utils_1.FundamentalUtils.getLucyIndication(operationalActivity),
            });
        }
        if (liquidFlow) {
            output.push({
                name: 'Fluxo de Caixa Liquido',
                value: fundamental_utils_1.FundamentalUtils.getLucyIndication(liquidFlow),
            });
        }
        if (investmentsActivity) {
            output.push({
                name: 'Atividades de Investimentos',
                value: fundamental_utils_1.FundamentalUtils.getLucyIndication(investmentsActivity),
            });
        }
        return output;
    }
    getDemoIndicators(data) {
        const { TotalReceipt: totalReceipt, GrossProfit: grossProfit, OperationalReceipt: operationalReceipt, } = data;
        const output = [];
        if (totalReceipt) {
            output.push({
                name: 'Geração de Receita',
                value: fundamental_utils_1.FundamentalUtils.getLucyIndication(totalReceipt),
            });
        }
        if (grossProfit) {
            output.push({
                name: 'Potencial Receita Bruta',
                value: fundamental_utils_1.FundamentalUtils.getLucyIndication(grossProfit),
            });
        }
        if (operationalReceipt) {
            output.push({
                name: 'Receitas Operacionais',
                value: fundamental_utils_1.FundamentalUtils.getLucyIndication(operationalReceipt),
            });
        }
        return output;
    }
    getSummary(indicators) {
        let qntBuy = 0;
        let qntSell = 0;
        let qntNeutral = 0;
        indicators.forEach((indicator) => {
            switch (indicator.value) {
                case lucy_1.eLucyFundamentalIndication.BUY:
                    return qntBuy++;
                case lucy_1.eLucyFundamentalIndication.SELL:
                    return qntSell++;
                case lucy_1.eLucyFundamentalIndication.STRONG_BUY:
                    return qntBuy++;
                case lucy_1.eLucyFundamentalIndication.STRONG_SELL:
                    return qntSell++;
                default:
                    return qntNeutral++;
            }
        });
        return {
            qntBuy,
            qntSell,
            qntNeutral,
        };
    }
    getInternalPoints(indicators) {
        let qntPoints = 0;
        indicators.forEach((indicator) => {
            switch (indicator.value) {
                case lucy_1.eLucyFundamentalIndication.BUY:
                    return qntPoints++;
                case lucy_1.eLucyFundamentalIndication.SELL:
                    return qntPoints--;
                case lucy_1.eLucyFundamentalIndication.STRONG_BUY:
                    qntPoints += 2;
                    break;
                case lucy_1.eLucyFundamentalIndication.STRONG_SELL:
                    qntPoints -= 2;
                    break;
            }
        });
        return qntPoints;
    }
}
exports.FundamentalIndication = FundamentalIndication;
//# sourceMappingURL=fundamental-indication.js.map